import { defineStore } from 'pinia'

export const usePlaybackStore = defineStore('playback', {
    state: () => ({
        resourceId: -1,
        resource: null, // object
        resourceType: null,
        status: null,
        currentTime: -1,
        duration: -1,
        mix: null, // mix object
        // browse-recently-played-mixes reads this, but nothing in the app writes
        // it and the Vuex module never declared it — so the feature has always
        // been inert. Declared so the read is at least reactive; the missing
        // writer is a separate question.
        history: [],
    }),
    actions: {
        setStatus({ currentTime, status, duration }) {
            this.currentTime = currentTime
            this.duration = duration
            this.status = status
        },
        setData({ resource, mix }) {
            this.resource = resource
            this.resourceId = (resource && resource.id) || null
            this.resourceType = (resource && resource.type) || null
            this.mix = mix
        },
    },
})
